import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Menu } from 'antd';
import Icon from 'component/icon';
import FavoritesIcon from './favoritesIcon';

const LeftMenu = (props) => {
    const {
        pages,
        setIsMenuOpen,
        currentRouteName,
        onClickMenu,
        logo,
        myFavorites,
        langConfig
    } = props;
    const [openKeys, setOpenKeys] = useState('');

    const groupKeys = useMemo(() => {
        const keys = pages?.map((pageGroup) => pageGroup.path || pageGroup.name) || [];
        if (myFavorites.open) {
            keys.push('favorites');
        }
        return keys;
    }, [pages, myFavorites]);

    const onChangeOpenKey = useCallback((keys) => {
        const key = keys?.[keys.length - 1] || '';
        if (groupKeys.includes(key)) {
            setOpenKeys([key]);
        } else if (key) {
            setOpenKeys([openKeys[0], key]);
        } else {
            setOpenKeys([]);
        }
    }, [groupKeys, openKeys]);

    useEffect(() => {
        const keys = [];
        pages?.forEach((pageGroup) => {
            pageGroup.children?.forEach((page) => {
                if (page.path === currentRouteName || pageGroup.name === currentRouteName) {
                    keys.push(pageGroup.path || pageGroup.name);
                } else if (page.children) {
                    const paths = page.children.map((subPage) => subPage.path);
                    if (paths.includes(currentRouteName)) {
                        keys.push(pageGroup.path || pageGroup.name);
                        keys.push(page.path || page.name);
                    }
                }
            });
        });
        setOpenKeys(keys);
    }, [pages, currentRouteName]);

    const dropDownMenuContent = useMemo(() => {
        const favoriteMenus = {
            key: 'favorites',
            label: langConfig?.favorite || '最愛',
            children: []
        };
        const addFavoritePages = (page) => {
            if (myFavorites.favoritePages.includes(page.key)) {
                favoriteMenus.children.push({
                    ...page,
                    key: `favorites-${page.key}`,
                    onClick: () => onClickMenu?.(page.key)
                });
            }
        };
        const dropDownMenus = pages?.map((pageGroup) => {
            const { path, name, children, icon } = pageGroup || {};
            const pageGroupObj = {
                key: path || (children?.length ? name : ''),
                label: name,
                children: children?.map((page) => {
                    const pageObj = {
                        key: page.path || (page.children?.length ? page.name : ''),
                        label: (
                            <div className="flex justify-between items-center">
                                <span>{page.name}</span>
                                {!page.children?.length && (
                                    <FavoritesIcon
                                        myFavorites={myFavorites}
                                        page={page.path}
                                        className="mr-3"
                                    />
                                )}
                            </div>
                        ),
                        children: page.children?.map((subPage) => {
                            const subPageObj = {
                                key: subPage.path || subPage.name,
                                label: (
                                    <div className="flex justify-between items-center">
                                        <span>{subPage.name}</span>
                                        <FavoritesIcon
                                            myFavorites={myFavorites}
                                            page={subPage.path}
                                            className="mr-3"
                                        />
                                    </div>
                                ),
                                icon: subPage.icon
                            };
                            addFavoritePages(subPageObj);
                            return subPageObj;
                        }),
                        icon: page.icon,
                        className: 'menu-layout'
                    };
                    addFavoritePages(pageObj);
                    return pageObj;
                }),
                icon
            };
            addFavoritePages(pageGroupObj);
            return pageGroupObj;
        });
        if (myFavorites.open && favoriteMenus.children.length) {
            dropDownMenus.push(favoriteMenus);
        }
        return (
            <Menu
                mode="inline"
                items={dropDownMenus}
                onClick={({ key }) => {
                    if (!key.includes('favorites-')) {
                        onClickMenu?.(key);
                    }
                }}
                selectedKeys={[currentRouteName]}
                className="bg-menu border-r border-r-transparent"
                onOpenChange={onChangeOpenKey}
                openKeys={openKeys}
                expandIcon={(menuProps) => (
                    <Icon
                        name={menuProps.isOpen ? 'expand_more' : 'chevron_right'}
                        size={20}
                        className
                    />
                )}
            />
        );
    }, [langConfig?.favorite, pages, currentRouteName, onClickMenu, openKeys, onChangeOpenKey, myFavorites]);

    return (
        <div className="h-full">
            <div className="bg-logo text-menu px-4 py-auto flex justify-between items-center
                h-[45px] overflow-y-hidden"
            >
                {logo}
                <Icon
                    name="keyboard_double_arrow_left"
                    size={24}
                    onClick={() => setIsMenuOpen(false)}
                    className="cursor-pointer text-[#FDD12E]"
                />
            </div>
            <div className="h-[calc(100%_-_45px)] overflow-auto hidden-scrollbar">
                {dropDownMenuContent}
            </div>
        </div>
    );
};

export default LeftMenu;
